export const SELECTED_USER = "SELECTED_USER";

export const PROFILES = "PROFILES";

export const LOADING_ITEMS = 25;
